import StyledAlert from 'src/components/Feedback/StyledAlert/StyledAlert'

export const CallAnalysisAlert = ({
  totalConnectedCalls,
  totalCallsWithAnalysis,
  callMetricsLoading,
}: {
  totalConnectedCalls: number
  totalCallsWithAnalysis: number
  callMetricsLoading: boolean
}) => {
  if (callMetricsLoading) {
    return null
  }

  return (
    <StyledAlert
      variant={
        totalConnectedCalls > 0 &&
        (totalCallsWithAnalysis / totalConnectedCalls) * 100 > 75
          ? 'error'
          : totalConnectedCalls > 0 &&
            (totalCallsWithAnalysis / totalConnectedCalls) * 100 > 50
          ? 'warning'
          : 'brand'
      }
      title={`${
        totalConnectedCalls > 0
          ? ((totalCallsWithAnalysis / totalConnectedCalls) * 100).toFixed(1)
          : 0
      }% of connected calls were found to have problems`}
      description={`Out of ${totalConnectedCalls} connected calls, ${totalCallsWithAnalysis} were found to have problems.`}
    />
  )
}
